<template>
  <ul
    :class="[
      'chart-li-wrap',
      direction ? direction : ''
    ]">
    <li
      v-for="(item, index) in list"
      :key="index"
      :class="[
        'chart-li__item',
        index === 0 ? 'first' : '',
        item.name ? 'code-names' : ''
      ]">
      <b v-if="item.name" :class="[ item.name == 'my' ? 'mine' : 'avarge',]"></b>
      <i
        v-else
        class="chart-li__circle"
        :style="{ background: item.color }" />
      <span class="chart-li__text">{{item.text}}</span>
      </li>
  </ul>
</template>

<script>
export default {
  name: 'ChartLi',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    direction: {
      type: String,
      default: 'center',
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .chart-li-wrap {
    display: flex;
    align-items: center;
    list-style: none;
    font-size: 0;
    width: 618px;
    margin: 0 auto;
    b {
      display: flex;
      margin-right: 12px;
      text-align: center;
      align-items: center;
      justify-content: center;
      &::after {
        content: '';
        width: 12px;
        height: 12px;
        display: block;
        border-radius: 100%;
      }
    }
    b.mine {
      &::after {
        background: rgba(0, 137, 255, 1);
        /*background-image: url("../images/mine_icon.png");*/
      }

    }
    b.avarge {
      &::after {
        flex: 0 0 auto;
        content: '';
        background: rgba(255, 154, 66, 1);
        /*background-image: url("../images/national_icon.png");*/
      }

    }
    &.left {
      justify-content: flex-start;
    }
    &.center {
      justify-content: center;
    }
    &.right {
      justify-content: flex-end
    }
    .chart-li__item {
      position: relative;
      margin-left: 48px;
      padding-left: 26px;
      &.first {
        margin-left: 0;
      }
    }
    .chart-li__item.code-names {
      padding-left: 0;
      display: flex;
      align-items: center;
    }
    .chart-li__circle {
      position: absolute;
      display: inline-block;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }
    .chart-li__text {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
  }
  .module-knowlege-level{
    .chart-li-wrap{
      justify-content: space-between;
      .chart-li__item{
        display: flex;
        align-items: center;
        margin-left: 0;
      }
    }
  }
  .module-testkmap-analysis,.module-learning-index{
    .chart-li-wrap{
      .chart-li__item{
        display: flex;
        align-items: center;
      }
    }
  }
</style>
